import { CollateralService, CollateralProvider, HttpService } from '@lk/api'

export const makeCollateralService = (http: HttpService, baseUrl: string) =>
  new CollateralService(new CollateralProvider(http, baseUrl))
